import React from 'react'
// libs
import { ReduxInput } from 'components/FormElements'
// types
import { FieldType, IField } from 'types/graphql'
// utils
import { required } from 'utils/validators'

interface Props {
  isForm?: boolean
  property: IField
}

const FieldInfo: React.FC<Props> = ({ isForm, property }) => {
  const isLabel = property.fieldType === FieldType.Label

  return (
    <>
      <ReduxInput name='object' label='Object' disabled />
      {!isForm && <ReduxInput name='grouping' label='Property Grouping' disabled />}
      <ReduxInput name='fieldType' label='Property Type' disabled />
      {!!property.parentField && <ReduxInput name='globalPropertyName' label='Global Property Name' disabled />}
      {(property.wysiwyg ? !isLabel: true) &&
        <ReduxInput
          name='name'
          validate={required}
          label={isLabel ? 'Label Text' : 'Name'}
          disabled={property.name === 'plan'}
        />
      }
    </>
  )
}

export default FieldInfo
